
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'
import CouponService from '@/services/lead/CouponService'
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    vSelect,
    VueSlider
  },
  computed: {
   ...mapGetters('auth', ['allowedFeature'])
  }
})

export default class Coupon extends Vue {
  private log(obj: any) {
    console.log(obj)
  }
  private couponService = new CouponService();

  private loadingCoupons: boolean = false;

  private couponForm: any = {};
  private isEdit: boolean = false;

  private couponObjsArr: any = [];
  private couponFields = [
    {key: 'code', label: 'Código', sortable: true},
    {key: 'discount_rate', label: 'Desconto', sortable: true},
    {key: 'fk_id_status', label: 'Status', sortable: true},
    {key: 'created_at', label: 'Criado em', sortable: true},
    {key: 'updated_at', label: 'Atualizado em', sortable: true},
    {key: 'id_coupon', label: '', sortable: false},
  ]

  private formatValue(value: string) {
    let decimalSeparator: any = null;
    value = String(value).replace(/[^0-9\.,]+/g, '');
    for (let i = value.length - 1; i >= 0; i--) {
      if (value.charAt(i) == '.' || value.charAt(i) == ',') {
          decimalSeparator = value.charAt(i);
        break;
      }
    }
    if (decimalSeparator != null) {
      value = value.replace(((decimalSeparator == '.') ? /,/g : /\./g), '');
      if (decimalSeparator == ',')
        value = value.replace(/,/, '.');
      return value;
    } return value;
  }

  private maskCouponValues(form: any) {
    let maskedForm: any = {}
    if (form && form !== {}) {
      if (!!form.discount_rate) {
        maskedForm.discount_rate = String(parseFloat(this.formatValue(form.discount_rate)) * 100).includes('.000000000000001') ?
          parseFloat(this.formatValue(form.discount_rate)) * 100 - 0.000000000000001 :
          parseFloat(this.formatValue(form.discount_rate)) * 100
      }

      maskedForm.code = form.code

      let status = form.fk_id_status == 24 ? 'Ativo' :
        form.fk_id_status == 25 ? 'Inativo' : undefined

      maskedForm.fk_id_status = status

      maskedForm.code = form.code
      maskedForm.id_coupon = form.id_coupon
    }
    return maskedForm
  }

  private unmaskCouponValues(form: any) {
    let unmaskedForm: any = {}
    if (form && form !== {}) {
      if (!!form.discount_rate) {
        unmaskedForm.discount = parseFloat(this.formatValue(form.discount_rate))
      }

      const status = form.fk_id_status == 'Ativo' ?
        'coupon_active' : form.fk_id_status == 'Inativo' ?
        'coupon_inactive' : undefined

      this.isEdit ? unmaskedForm.fk_id_status = status : unmaskedForm.status = status

      unmaskedForm.code = form.code
      unmaskedForm.id_coupon = form.id_coupon
    }
    return unmaskedForm
  }

  private async getCoupons() {
    this.loadingCoupons = true;
    this.couponObjsArr = [];
    this.couponObjsArr = await this.couponService.index()
    this.loadingCoupons = false;
  }

  private openEditModal(id_coupon: number) {
    this.couponForm = {}
    this.isEdit = true;

    for (let obj of this.couponObjsArr) {
      if (obj.id_coupon == id_coupon) {
        this.couponForm = obj
        break
      }
    }
    this.couponForm = this.maskCouponValues(this.couponForm)
    this.$bvModal.show('modal-coupon-edit')
  }

  private closeEditModal() {
    this.couponForm = {}
    this.isEdit = true;
    this.$bvModal.hide('modal-coupon-edit')
  }

  private async editCoupon() {
    if (!this.couponForm.code || !this.couponForm.fk_id_status) {
      this.$store.commit("navBarAlert/DANGER_ALERT", '"Código" e "Status" são campos obrigatórios');
      return false
    }

    try {
      this.couponForm = this.unmaskCouponValues(this.couponForm);

      const resultCreateCoupon = await this.couponService.update(
          this.couponForm.id_coupon,
          this.couponForm.code,
          this.couponForm.fk_id_status,
          this.couponForm.discount,
      );
      resultCreateCoupon ?
      this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Cupom atualizado com sucesso') :
      this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao atualizar o cupom, tente novamente');
    } catch (error) {
        console.log(error);
        this.$store.commit("navBarAlert/DANGER_ALERT", 'ALERTA: erro inesperado');
    }

    this.closeEditModal()
    await this.getCoupons();
  }

  private async createCoupon() {
    if (!this.couponForm.code || !this.couponForm.fk_id_status) {
      console.log(this.couponForm)
      this.$store.commit("navBarAlert/DANGER_ALERT", '"Código" e "Status" são campos obrigatórios');
      return false
    }

    try {
        this.couponForm = this.unmaskCouponValues(this.couponForm);

        const resultCreateCoupon = await this.couponService.store(
            this.couponForm.code,
            this.couponForm.discount,
            this.couponForm.status
        );

        resultCreateCoupon ?
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Cupom salvo com sucesso!') :
        this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao salvar o cupom, tente novamente');

    } catch (error) {
        console.log(error);
        this.$store.commit("navBarAlert/DANGER_ALERT", 'ALERTA: erro inesperado');
    }

    this.closeCreateModal()
    await this.getCoupons();
  }

  private openCreateModal(newCouponForm: {}) {
    this.couponForm = {}
    this.$bvModal.show('modal-coupon-create')
  }

  private closeCreateModal() {
    this.couponForm = {}
    this.$bvModal.hide('modal-coupon-create')
  }

  private async created() {
    this.getCoupons();
  }
}
